import React from "react";
import Session from "../../services/Session";
import { Spinner, NonIdealState, H1, H2, H3, H4 } from "@blueprintjs/core";
import { base } from "../../fire";
import Logo from "../Results/common/Footer";

import Participant from "../../services/Participant";
import Auth from "../../services/Auth";

import DialogCreateParticipant from "./DialogCreateParticipant";
import InProgressSession from "./InProgressSession";
import StepInterlude from "./InProgressSession/Steps/Interlude";
import ResourceViewer from "./InProgressSession/ResourceViewer";

import { Redirect } from "react-router-dom";
import { translate } from "utlis/translations/i18n";

var QRCode = require("qrcode.react");

class SessionPiloted extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Get participant info of the user joining the session, if they exists
      participant: Participant.getBySessionId(this.props.session.id) || null,
      alertCreateParticipantOpened: true,
      // Instance of the session launched
      windowSize: window.innerWidth,
      sessionInstance: {},
      sessionInstanceLoading: true,
    };
  }

  handleCloseCreateParticipantAlert = () =>
    this.setState({ alertCreateParticipantOpened: false });
  handleCreateParticipant = (createParticipantInfos) => {
    const { sessionInstance } = this.state;
    const { session } = this.props;
    console.log("session", session);
    const { metadata } = session;
    const { author } = metadata;
    const { participants = [] } = sessionInstance;
    const participant = Participant.createForSession(
      session.id,
      createParticipantInfos,
      author
    );

    participants.push(participant);
    this.setState({
      participant,
      sessionInstance: { ...sessionInstance, participants },
    });
    this.handleCloseCreateParticipantAlert();
  };

  render() {
    const {
      participant,
      alertCreateParticipantOpened,
      sessionInstance,
      sessionInstanceLoading,
    } = this.state;
    const { session } = this.props;
    const { id, metadata } = session;
    const { author } = metadata;

    if (sessionInstanceLoading)
      return (
        <div>
          <Spinner />
        </div>
      );
    if (
      Auth.isAuth() &&
      Auth.getUserId() === metadata.author &&
      this.state.windowSize < 950
    )
      return (
        <Redirect
          to={`/monitor/${Auth.getUserId()}/${session.metadata.shortname}`}
        />
      );
    if (Auth.isAuth() && Auth.getUserId() === metadata.author)
      return (
        <ProjectionScreen
          history={this.props.history}
          sessionInstance={sessionInstance}
          session={session}
        />
      );
    if (!participant)
      return (
        <DialogCreateParticipant
          isOpen={alertCreateParticipantOpened}
          onCreateParticipant={this.handleCreateParticipant}
          id={id}
          author={author}
        />
      );
    return (
      <InProgressSession
        instance={{ ...sessionInstance, id: this.instanceId }}
        session={session}
      />
    );
  }

  componentWillMount() {
    const { session } = this.props;
    const { sequences } = session.data;
    const initInstanceResults = {};

    // Build the initial state of result object (only used at instance creation) of each sequence
    sequences.forEach(
      (s) => (initInstanceResults[s.id] = { _fakeId: "_fakeResult" })
    );
    // Get existing SessionInstance
    // If no existing instance, we create it
    // We retrieve the SessionInstance id to be able to build the endpoint for the base.syncState
    // We syncState the SessionInstance to be able to track any changes made by the Session Master
    Session.getPilotedSessionInstanceIdById(session.id)
      .then((instanceId) => {
        if (!instanceId)
          return Session.createPilotedSessionInstance(session.id, {
            created: Date.now(),
            type: "PILOTED",
            currentStep: "HOME", // Use a Session Instance constant
            currentSequence: 0,
            currentInterlude: 0,
            currentConclusion: 0,
            currentSequenceResource: 0,
            results: initInstanceResults,
            participants: [],
          }).then(() => Session.getPilotedSessionInstanceIdById(session.id));
        return instanceId;
      })
      .then((instanceId) => {
        this.instanceId = instanceId;
        this.syncSessionInstanceRef = base.syncState(
          `sessionInstances/${session.id}/${instanceId}`,
          {
            context: this,
            state: "sessionInstance",
            then: () => this.setState({ sessionInstanceLoading: false }),
          }
        );
      });
  }
  componentWillUnmount() {
    if (this.syncSessionInstanceRef)
      base.removeBinding(this.syncSessionInstanceRef);
  }
}

class ProjectionScreen extends React.Component {
  redirectToResults = () => {
    this.props.history.push(
      `/resultats/${this.props.session.metadata.author}/${this.props.session.id}`
    );
  };

  render() {
    const { sessionInstance, session } = this.props;
    const { currentStep, currentInterlude, currentConclusion } =
      sessionInstance;
    const { data } = session;
    const { interludes, feedbacks = [], conclusions } = data;
    const URL = session.metadata.shortUrl;
    const fullURL = `https://visual-sense-session.web.app/#/play/${session.metadata.author}/${session.metadata.shortname}`;
   

    switch (currentStep) {
      case "HOME": // Use a Step constant from SessionInstance
        return (
          <>
            <NonIdealState
              id="large-bp3"
              icon="tick"
              title={translate("imminentStart")}
              description={translate("scanQRCodeOr")}
            >
              <QRCode
                value={fullURL}
                size={300}
                bgColor={"#ffffff"}
                fgColor={"#000000"}
                level={"L"}
                includeMargin={true}
                renderAs={"svg"}
                style={{ marginTop: 30 }}
              />
              <H2>{URL}</H2>
            </NonIdealState>
            <div className="foot">
              <H3>{translate("privacyPolicy")}:</H3>
              <H4>{translate("privacyPolicyText")}</H4>
            </div>
          </>
        );
      case "INTERLUDES":
        return (
          <StepInterlude
            session={session}
            instance={sessionInstance}
            interludes={interludes}
            current={currentInterlude}
          />
        );
      case "SEQUENCES":
        return (
          <ResourceViewer
            sessionInstance={sessionInstance}
            session={session}
            showIndexInLegend={true}
          />
        );
      case "CONCLUSIONS":
        return (
          <StepInterlude
            session={session}
            instance={sessionInstance}
            interludes={conclusions}
            current={currentConclusion}
          />
        );

      case "FEEDBACKS":
        if (feedbacks.length === 0)
          return (
            <div className="piloted-session-over">
              <Logo noText={true} />
              <H1>{translate("thanksForParticipation")}</H1>
              <H2>{translate("youFinishedSession")}</H2>
            </div>
          );
        if (feedbacks.length !== 0)
          return (
            <div className="piloted-session-over">
              <Logo noText={true} />
              <H1>{translate("thanksForParticipation")}</H1>
              <H2>{translate("youFinishedSession")}</H2>
              <div className="feedback-box-piloted">
                <H2 style={{ marginBottom: "10px" }}>
                  {translate("feedbackQuestions")} :
                </H2>
                {feedbacks.map((feedback) => (
                  <H2>
                    - {feedback.question}{" "}
                    {feedback.leftLegend && feedback.rightLegend && (
                      <span>
                        ( {feedback.leftLegend} - {feedback.rightLegend} )
                      </span>
                    )}
                  </H2>
                ))}
              </div>
            </div>
          );
        break;
      case "RESULTS":
        this.redirectToResults();
        return <></>;
      default:
        return <p>{translate("player.unknownStep")}</p>;
    }
  }

  componentDidMount() {
    const { session } = this.props;
    const { data } = session;
    const { sequencesResources = [], interludes = [] } = data;

    sequencesResources.forEach((resource) => {
      const image = new Image();

      image.onload = () =>
        console.log(`Image preloaded (${resource.downloadURL})`);
      image.onerror = () =>
        console.error(`IPreloading failed (${resource.downloadURL})`);
      image.src = resource.downloadURL;
    });
    interludes.forEach((interlude) => {
      const image = new Image();

      image.onload = () =>
        console.log(`Image preloaded (${interlude.downloadURL})`);
      image.onerror = () =>
        console.error(`Preloading failed (${interlude.downloadURL})`);
      image.src = interlude.downloadURL;
    });

    document.body.style.background = "rgba(0,0,0,1)";
    document.body.style.padding = "0";
    document.body.style.overflowY = "hidden";
  }

  componentWillUnmount() {
    document.body.style.background = null;
    document.body.style.padding = null;
    document.body.style.overflowY = null;
  }
}

export default SessionPiloted;
